import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Sun, Moon, Monitor, Zap } from 'lucide-react'
import { useThemeStore } from '@/shared/store/themeStore'
import { useAuth } from '@/platform/auth/useAuth'
import { ExperienceControl } from '@/platform/experiences/components/ExperienceControl'
import styles from './MobileHeader.module.css'

export function MobileHeader() {
  const { theme, setTheme } = useThemeStore()
  const { user } = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  const cycleTheme = () => {
    const next = theme === 'dark' ? 'light' : theme === 'light' ? 'system' : 'dark'
    setTheme(next)
  }

  const ThemeIcon = theme === 'dark' ? Moon : theme === 'light' ? Sun : Monitor

  // Determine section title based on active path
  const getSectionTitle = () => {
    const path = location.pathname
    if (path.startsWith('/today') || path === '/dashboard' || path === '/') return 'Today'
    if (path.startsWith('/plan') || path.startsWith('/planner')) return 'Daily Plan'
    if (path.startsWith('/goals')) return 'Goals'
    if (path.startsWith('/learning') || path.startsWith('/celpip')) return 'Learning Hub'
    if (path.startsWith('/french')) return 'French NCLC 7'
    if (path.startsWith('/calendar')) return 'Calendar'
    if (path.startsWith('/more') || path.startsWith('/settings')) return 'Settings & Tools'
    if (path.startsWith('/gita')) return 'Bhagavad Gita'
    return 'NTTD'
  }

  return (
    <header className={styles.mobileHeader}>
      <div className={styles.left}>
        <button
          className={styles.brandButton}
          onClick={() => navigate('/dashboard')}
          aria-label="Go to Today"
        >
          <div className={styles.logo}>
            <Zap size={18} strokeWidth={2.5} />
          </div>
          <span className={styles.title}>{getSectionTitle()}</span>
        </button>
      </div>

      <div className={styles.right}>
        <ExperienceControl />

        <button
          className={styles.iconBtn}
          onClick={cycleTheme}
          aria-label={`Current theme: ${theme}. Click to change.`}
          title={`Theme: ${theme}`}
        >
          <ThemeIcon size={16} />
        </button>

        {user ? (
          <button
            className={styles.avatarBtn}
            onClick={() => navigate('/more')}
            aria-label="Open profile and settings"
            title={`${user.name} (${user.email})`}
          >
            <span className={styles.avatar}>
              {user.name.charAt(0).toUpperCase()}
            </span>
          </button>
        ) : (
          <button
            className={styles.loginBtn}
            onClick={() => navigate('/login')}
          >
            Sign In
          </button>
        )}
      </div>
    </header>
  )
}
